import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { BanksService } from '../../../../services/common';
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';

@Component({
  selector: 'app-bank-list',
  templateUrl: './bank-list.component.html',
  styleUrl: './bank-list.component.scss'
})

export class BankListComponent implements OnChanges {
  @Input() bankListData: any;
  @Output() changeModalStatus = new EventEmitter<any>();
  @Output() deleteBankAccount = new EventEmitter<any>();
  columnDefs!: any[]
  defaultColDef: any
  bankAccountData: any[] = [];
  gridColumnApi: any;
  frameworkComponents: any;
  context: any;
  constructor(private bankService: BanksService) { this.context = this }

  ngOnInit() {
    this.bankAccountData = this.mapBankData(this.bankListData);
    this.getBankDetails();
    this.agGridHeaderList();
    this.agGridHeaderFilter()
    this.bankService.isBankAccountExist = false;
  }

  /**
   * Detect changes to bankListData input
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['bankListData'] && !changes['bankListData'].firstChange) {
      // Update bankAccountData when bankListData changes
      this.bankAccountData = this.mapBankData(this.bankListData);
    }
  }

  /**
   * Helper method to map nested bank name to flat field
   */
  mapBankData(data: any[]): any[] {
    return (data || []).map((item: any) => ({
      ...item,
      bankName: item.bank?.bankName || item.bankName || ''
    }));
  }

  /**
   *
   * @param currentRecord current record which is selected from it's action
   * @param context context to be send to add/update bank form
   */
  changeAddUpdateModalState(currentRecord?: any, context?: string) {
    //this.bankService.isBankAccountExist = true;
    this.changeModalStatus.emit({
      "showaddUpdateModal": true,
      "currentSelectedRecord": currentRecord,
      "context": context
    })
  }

  /**
   * Ag Grid Header Field
   */
  agGridHeaderList() {
    this.columnDefs = [
      { header: "Bank Name", field: "bankName", tooltipField: "bankName", columnType: 'text' },
      { header: "Branch", field: "branchName", tooltipField: "branchName", columnType: 'text' },
      { header: "Address", field: "branchAddress", tooltipField: "branchAddress", columnType: 'text', maxTextLength: 15 },
      {
        header: "Actions",
        field: 'action',
        columnType: 'icon',
        config: {
          icons: [
            { name: 'edit', icon: 'fa-pencil', color: 'success', tooltip: 'Edit Bank Account' },
            { name: 'delete', icon: 'fa-trash', color: 'error', tooltip: 'Delete Bank Account' }
          ]
        }
      }
    ];
  }

  /**
   * Ag Grid Header Filter and Sorting
   */
  agGridHeaderFilter() {
    this.defaultColDef = {
      editable: false,
      sortable: true,
      filter: true,
      resizable: false,
    };
  }

  /**
   * get bank details using ifsc code
   */
  getBankDetails() {
    this.bankService.getBankDetails().subscribe(data => {
      if (data) {
        const mappedData = {
          ...data,
          bankName: data.bank?.bankName || data.bankName || ''
        };
        this.bankAccountData.push(mappedData);
        // this.gridApi.setRowData(this.bankAccountData);
      }
    })
  }

  /**
   * Handle icon click action from table
   */
  onRowAction(event: { action: string; row: any }): void {
    if (event.action === 'edit') {
      this.changeAddUpdateModalState(event.row, 'edit');
    } else if (event.action === 'delete') {
      this.deleteBankAccount.emit(event.row);
    }
  }
}
